module.exports = __webpack_public_path__ + "img/04.5186848b.png";